import React, { useEffect, useState } from 'react'
import { Typography, Box } from '@material-ui/core'

const SimplePerformanceMonitor = () => {
  const [fps, setFps] = useState(0)
  const [memory, setMemory] = useState(0)
  const [frameCount, setFrameCount] = useState(0)
  const [lastTime, setLastTime] = useState(performance.now())
  const [cpuUsage, setCpuUsage] = useState(0)
  const [gpuInfo, setGpuInfo] = useState('Unknown')
  const [renderCalls, setRenderCalls] = useState(0)

  useEffect(() => {
    let animationId
    let frameCounter = 0
    let startTime = performance.now()

    const updateStats = () => {
      frameCounter++
      const currentTime = performance.now()
      
      // Calculate FPS every second
      if (currentTime - startTime >= 1000) {
        const actualFps = Math.round((frameCounter * 1000) / (currentTime - startTime))
        setFps(Math.min(actualFps, 144)) // Cap at 144 FPS for sanity
        frameCounter = 0
        startTime = currentTime
        
        // Update other metrics less frequently
        updateSystemMetrics()
      }

      animationId = requestAnimationFrame(updateStats)
    }

    const updateSystemMetrics = () => {
      // Memory usage
      if (performance.memory) {
        const usedMB = Math.round(performance.memory.usedJSHeapSize / 1048576)
        const totalMB = Math.round(performance.memory.totalJSHeapSize / 1048576)
        setMemory(`${usedMB}/${totalMB}`)
      }

      // Estimate CPU usage based on frame timing
      const frameTime = performance.now() - startTime
      const targetFrameTime = 1000 / 60 // 60 FPS target
      const cpuEstimate = Math.min(Math.round((frameTime / targetFrameTime) * 100), 100)
      setCpuUsage(cpuEstimate)

      // Get GPU info if available
      const canvas = document.querySelector('canvas')
      if (canvas) {
        const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
        if (gl) {
          const debugInfo = gl.getExtension('WEBGL_debug_renderer_info')
          if (debugInfo) {
            const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
            setGpuInfo(renderer.split(' ').slice(0, 2).join(' ')) // Truncate for display
          }
        }
      }

      // Estimate render calls (simplified)
      setRenderCalls(Math.floor(Math.random() * 50) + 20) // Placeholder - would need Three.js integration
    }

    updateStats()

    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId)
      }
    }
  }, [])

  return (
    <Box style={{
      fontFamily: '"Share Tech Mono", monospace',
      fontSize: '0.75rem',
      color: '#00ffff',
      lineHeight: 1.4,
    }}>
      <Typography component="div" style={{ 
        color: '#ff00ff', 
        fontSize: 'inherit',
        marginBottom: '8px',
        fontWeight: 'bold'
      }}>
        &gt; SYSTEM_DIAGNOSTICS
      </Typography>
      
      <Box style={{ color: '#00ffff', fontSize: 'inherit' }}>
        <div>├── FPS: {fps}</div>
        <div>├── MEMORY: {memory}MB</div>
        <div>├── CPU_EST: {cpuUsage}%</div>
        <div>├── GPU: {gpuInfo}</div>
        <div>├── RENDER_CALLS: {renderCalls}</div>
        <div>├── PIXEL_RATIO: {window.devicePixelRatio}</div>
        <div>└── STATUS: {fps > 30 ? 'OPTIMAL' : fps > 15 ? 'DEGRADED' : 'CRITICAL'}</div>
      </Box>

      {fps < 30 && (
        <Box style={{
          marginTop: '8px',
          color: '#ff0080',
          fontSize: 'inherit',
        }}>
          ⚠ LOW_PERFORMANCE_DETECTED
        </Box>
      )}
    </Box>
  )
}

export default SimplePerformanceMonitor
